import {AfterContentChecked, Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: 'textarea[autosize]'
})
export class AutosizeTextareaDirective implements AfterContentChecked {

  public constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  public ngAfterContentChecked() {
    this.adjust();
  }

  @HostListener('input')
  public onInput() {
    this.adjust();
  }

  private adjust(): void {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto'; // reset to shrink if needed
    textarea.style.height = `${textarea.scrollHeight + 10}px`; // grow to fit content
  }

}
